module.exports = __webpack_public_path__ + "img/aboutBoat.9e51065d.jpeg";